/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { jsmEmailDomainsListResource } from '@jira/router-resources__get-email-domains-list/src/jsmEmailDomainsListResource.tsx';
import { productsJsmOrganizationDetailsResource } from '@jira/router-resources__organization-details/src/productsJsmOrganizationDetailsResource.tsx';
import { productsJsmOrganizationMembersResource } from '@jira/router-resources__organization-members/src/productsJsmOrganizationMembersResource.tsx';
import { productsJsmOrganizationListResource } from '@jira/router-resources__organizations-list/src/productsJsmOrganizationListResource.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJsmOrganizationsDetailsRoute } from '@jira/router-routes__products-jsm-organizations-routes/src/productsJsmOrganizationsDetailsRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';
import ProductsJsmOrganizationDetails, {
	LazyProductsJsmOrganizationDetails,
} from './ui/admin-pages/products-jsm-organization-details/index.tsx';

export const productsJsmOrganizationsDetailsRouteEntry: Route = createEntry(
	productsJsmOrganizationsDetailsRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsm-organization-page-list',
		isRedirect: false,
		// eslint-disable-next-line no-restricted-syntax
		component: ProductsJsmOrganizationDetails,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			productsJsmOrganizationDetailsResource,
			productsJsmOrganizationMembersResource,
			productsJsmOrganizationListResource,
			jsmEmailDomainsListResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyProductsJsmOrganizationDetails],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
